import type { JobEndDetail } from '@/api/types/jobEnd.types';

export interface ValidationErrors {
  natureOfRole: boolean;
  skillRatings: boolean;
  strengthsDev: boolean;
}

export const NO_ERRORS: ValidationErrors = {
  natureOfRole: false,
  skillRatings: false,
  strengthsDev: false,
};

export function validateJobEnd(
  jobEnd: JobEndDetail,
  showNatureOfRole: boolean,
  showSkillRatings: boolean,
): ValidationErrors {
  const ratings = jobEnd.activityRatings || [];
  const activities = jobEnd.natureOfRoleActivities || [];
  const allRatingsFilled = activities.every((activityType) =>
    ratings.some((r) => r.activityType === activityType && r.rating !== null)
  );

  const hasContent = (html: string) => html.replace(/<[^>]*>/g, '').trim() !== '';
  const strengthsWithContent = (jobEnd.strengthFeedbacks || []).filter((f) => hasContent(f.content));
  const devAreasWithContent = (jobEnd.developmentAreaFeedbacks || []).filter((f) => hasContent(f.content));

  // Validate skill ratings: overall must be set and all individual skills must be rated
  let skillRatingsIncomplete = false;
  if (showSkillRatings && jobEnd.skillRatings) {
    const { overallRating, skillAreas } = jobEnd.skillRatings;
    const allSkillsRated = skillAreas.every((area) => area.skills.every((s) => s.rating !== null));
    skillRatingsIncomplete = overallRating === null || !allSkillsRated;
  }

  return {
    natureOfRole: showNatureOfRole && !allRatingsFilled,
    skillRatings: skillRatingsIncomplete,
    strengthsDev: strengthsWithContent.length < 3 || devAreasWithContent.length < 3,
  };
}
